<template>
  <div class="price-content">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="店铺名称" prop="storeCode">
          <el-select v-model="searchForm.storeCode" multiple collapse-tags clearable style="width: 240px">
            <el-option v-for="item in storeList" :key="item.storeCode" :label="item.shortName" :value="item.storeCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调整类型" prop="adjustType">
          <el-select v-model="searchForm.adjustType" clearable multiple collapse-tags>
            <el-option label="销售状态" value="销售状态"></el-option>
            <el-option label="发货周期" value="发货周期"></el-option>
            <el-option label="SKU推广名称" value="SKU推广名称"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通知时间">
          <form-date-range
            :form="searchForm"
            startKey="dts"
            endKey="dte"
            :usingTime="false"
            valueFormat="yyyy-MM-dd"
          ></form-date-range>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
      </template>
    </search-box>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table stripe border ref="tableRef" :data="tableData.list" :height="maxTableHeight" v-if="tableReload" v-loading="loading">
        <el-table-column prop="storeName" label="店铺名称" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="userName" label="负责人" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="adjustType" label="调整类型" min-width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="needQty" label="需处理商品数" min-width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="waiteQty" label="待处理商品数" min-width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="cannotQty" label="暂缓处理消息数" min-width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="dealedQty" label="已处理商品数" min-width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="notOnsaleQty" label="未上架商品数" min-width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="finishRate" label="处理完成率" min-width="110" show-overflow-tooltip>
          <template #header>
            <span>处理完成率</span>
            <el-tooltip class="item" effect="dark" content="（已处理商品数据 + 未上架商品数据 ） / 需处理商品数；" placement="top">
              <span class="el-icon-question"></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="days" label="平均完成耗时天数" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row }">
            <el-button type="text" @click="viewDetails(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import moment from 'moment';

export default {
  name: 'PriceContent',
  mixins: [tableMixin, pagePathMixin],
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      storeList: [],
      searchForm: {
        storeCode: [],
        adjustType: [],
        dts: moment().subtract(3, 'month').format('YYYY-MM-DD'),
        dte: moment().format('YYYY-MM-DD'),
      },
      // 店铺标签页
      activeTab: undefined,
      storeTabs: [],
    };
  },
  mounted() {
    let query = this.$route.query;
    if (query.dts && query.dte) {
      this.searchForm.dts = query.dts;
      this.searchForm.dte = query.dte;
    }
    this.onSearch();
    this.getStoreList();
  },
  methods: {
    handleTabClick() {
      this.onSearch();
    },

    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },

    async init() {
      this.loading = true;
      let { skuCodes, adjustType } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          type: 3,
        },
      };
      this.searchFormData = data;
      this.$q.newProduct
        .onSaleUpdateStorePage({ data: data })
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    onReset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    viewDetails(row) {
      // type: 3-其他信息变更
      this.$emit('view-details', {
        type: 3,
        row: row,
      });
    },

    getStoreList() {
      let data = {
        pageNum: 1,
        pageSize: 999999,
        filterData: {
          newArrival: 1,
        },
      };
      this.$q.configurationCenter.storeManagePage({ data: data }).then(res => {
        if (res.code == 200) {
          this.storeList = res.data.list;
        }
      });
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-api',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'storeTotalData',
      };
      this.$q.common.exportExcel({ data: params }).then(res => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.price-content {
  >>> .search-outer>div {
    padding: 0;
  }
}

.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}

.tabs-row {
  margin-bottom: 5px;
}

.tabs {
  >>> .el-tabs__header {
    margin: 0 !important;
  }
}

.occupy {
  width: 200px;
  height: 20px
}

.table-btn-area {
  text-align: right;
  line-height: 40px;
}

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

  >>> .form-number-input .el-input-number {
      width: 105px !important;
  }
  >>> .form-number-input .el-input-number .el-input {
      width: 105px !important;
  }
</style>
